import { BillingDto } from '@api/client';
import { useMemo } from 'react';

const useGetBillingTotals = (billingPlan: BillingDto[] | undefined) => {
  const totalAmount = useMemo<number>(() => {
    return billingPlan?.reduce((total, el) => total + (el.amount ?? 0), 0) ?? 0;
  }, [billingPlan]);

  const totalSalAmount = useMemo<number>(() => {
    return (
      billingPlan?.reduce((total, el) => {
        const salListTotal =
          el.statoAvanzamentoLavoriList?.reduce((salTotal, sal) => salTotal + (Number(sal.importo) || 0), 0) ?? 0;
        return total + salListTotal;
      }, 0) ?? 0
    );
  }, [billingPlan]);

  return {
    totalAmount,
    totalSalAmount,
  };
};

export default useGetBillingTotals;
